import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import { ThreeDots } from 'react-loader-spinner';
import { resetList, getSite, updateSite, updateSiteID, addSite, deleteSiteID, getSiteID } from "../../3.Store/SiteSlice";

const SiteForm = () => {
  const { sid } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(state => state.CompanySlice.loading);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const site = useSelector(state => state.SiteSlice.site);
  const { id, description, short_description } = site;

  useEffect(() => {
    console.log("Site ID:", sid);
    window.scrollTo(0, 0);
    if (sid) {
      dispatch(getSiteID({sid}))
        .catch((err) => {
          console.error("Failed to fetch site details:", err);
        });
    } else {
      dispatch(resetList());
    }
  }, [sid]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleBtnAdd = () => {
    const entity = { ...site };
    console.log(entity);
    dispatch(addSite(entity))
      .unwrap()
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Site added successfully",
          confirmButtonColor: "#4fa94d",
        }).then(() => {
          dispatch(resetList());
          navigate("/Site");
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: (error.response.data || error.message),
          confirmButtonColor: "#4fa94d",
        });
      });
  };

  const handleBtnBack = () => {
    dispatch(resetList());
    navigate("/Site");
  };

  const handleUpdate = (e) => {
    const entity = { ...site, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateSite(entity));
  };

  const handleBtnUpdate = () => {
    const entity = { ...site };
    console.log(entity);
    dispatch(updateSiteID(entity))
      .unwrap()
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Site updated successfully",
          confirmButtonColor: "#4fa94d",
        }).then(() => {
          dispatch(resetList());
          navigate("/Site");
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: (error.response.data || error.message),
          confirmButtonColor: "#4fa94d",
        });
      });
  };

  const handleBtnDelete = () => {
    Swal.fire({
      title: 'Do you want to delete this site?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        const entity = { ...site };
        console.log(entity);
        dispatch(deleteSiteID(entity))
          .unwrap()
          .then(() => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Site deleted successfully",
              confirmButtonColor: "#4fa94d",
            }).then(() => {
              dispatch(resetList());
              navigate("/Site");
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: (error.response.data || error.message),
              confirmButtonColor: "#4fa94d",
            });
          });
      }
    });
  };

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Site</h1>
        <h1 className="MiniTitleHeader">{sid ? "Edit" : "Add"}</h1>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Short Description</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="short_description" value={short_description} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={12} sm={12}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Description</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control name="description" value={description} onChange={handleUpdate}/>
              </Col>
            </Row>
          </Col>
        </Row>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            {sid ? (
              <>
              <Button className="Button" onClick={handleBtnDelete}>
                Delete
              </Button>
              &nbsp; &nbsp;
              <Button className="Button" onClick={handleBtnUpdate}>
                Update
              </Button>
              </>
            ) : (
              <Button className="Button" onClick={handleBtnAdd}>
                Add
              </Button>
            )}
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};

export default SiteForm;